import { render, staticRenderFns } from "./CaseTaskDialog.vue?vue&type=template&id=8f52497e"
import script from "./CaseTaskDialog.vue?vue&type=script&lang=js"
export * from "./CaseTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports